exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-container {\r\n  padding-top: 38px;\r\n}\r\n\r\n.flash {\r\n  margin: 2px;\r\n}\r\n\r\n.cutoff {\r\n  margin: 4px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/pages/content-calendar/send-email-modal/styles.css
// module id = 2649
// module chunks = 29